import FeatureTourForm from 'pages/shared/FeatureTourForm'
import FeatureTour from 'models/FeatureTour'

import { SinglePanePage } from 'styles/shared'

const AddFeatureTour = () => (
  <SinglePanePage>
    <FeatureTourForm
      title="New Feature Tour"
      featureTour={new FeatureTour()}
      validatedSaveType="create"
    />
  </SinglePanePage>
)

export default AddFeatureTour
